export const CHANGE_SITE_INFO = "CHANGE_SITE_INFO";
